import {assert} from 'Asserts';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {isBioentityFieldColumn} from 'notebook/registration-tables/RegistrationTableColumnDefinitions';
import {
  LegacyRegistrationTableLoadExistingBioentityCustomEvalQuery,
  ServerResolutionResult,
  StringResolutionType,
} from 'notebook/tables/string-resolution/StringResolutionConstants';
import {TableColumnType} from 'notebook/tables/TableConstants';
import {convertTagToTypedValue, toStringTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {BaseTypedValueType} from 'notebook/tables/typed-values/TypedValueConstants';
import {findSchemaTagByApiId} from 'schemas/tags/TagUtil';

import makeCustomResolutionResultFromTypedValue from '../samples/transfer-table-columns/makeCustomResolutionResultFromTypedValue';
import doBioentityQuery from './BioentityGQLQuery';

export async function loadExistingBioentityCustomEval(
  query: LegacyRegistrationTableLoadExistingBioentityCustomEvalQuery
): Promise<ServerResolutionResult> {
  const {bioentityId, columnDefinition, tagSchema} = query;
  const data = await doBioentityQuery(bioentityId);
  const bioentitySummary = data.directBioentity;
  if (isInaccessible(bioentitySummary)) {
    return makeCustomResolutionResultFromTypedValue(toStringTypedValue(''));
  }

  const isBioentityNameColumn = columnDefinition.type === TableColumnType.BIOENTITY_NAME;
  const isBioentitySchemaFieldColumn =
    columnDefinition.type === TableColumnType.TAG_VALUE &&
    isBioentityFieldColumn(columnDefinition, tagSchema);

  if (isBioentityNameColumn) {
    return {
      type: StringResolutionType.CUSTOM,
      resolvedValue: {
        typedValue: {
          type: BaseTypedValueType.STRING,
          rawValue: bioentitySummary.name,
        },
      },
      error: null,
    };
  } else if (columnDefinition.type === TableColumnType.DNA_BASES) {
    assert(bioentitySummary.__typename === 'SequenceNode', 'Expected sequence node');
    return {
      type: StringResolutionType.CUSTOM,
      resolvedValue: {
        typedValue: {
          type: BaseTypedValueType.STRING,
          rawValue: bioentitySummary.bases,
        },
      },
      error: null,
    };
  } else {
    assert(isBioentitySchemaFieldColumn, 'Unexpected column type for existing bioentity');
    const schemaTag = findSchemaTagByApiId(bioentitySummary.tagsJson, columnDefinition.tagSchemaFieldApiId);
    if (!schemaTag) {
      // handle sparse tags
      return {
        type: StringResolutionType.CUSTOM,
        resolvedValue: {typedValue: {type: BaseTypedValueType.STRING, rawValue: ''}},
        error: null,
      };
    } else {
      return {
        type: StringResolutionType.CUSTOM,
        resolvedValue: {typedValue: convertTagToTypedValue(schemaTag)},
        error: null,
      };
    }
  }
}
